<template>
  <quoteBasic
    :title="'Refer Dealer Leads'"
    :propsMode="'new'"
    :quoteType="'leads'"
    :leadSource="'RDL'"
  ></quoteBasic>
</template>
<script>
import quoteBasic from '../../../components/quote/quoteBasic.vue'

export default {
  name: 'LeadsNew',
  components: {
    quoteBasic
  }
}
</script>
